import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Interaction } from 'src/app/pages/interactions/interaction.model';

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss']
})
export class VideoComponent implements OnInit {

  @Input() interaction: Interaction;
  @Output() addInteraction = new EventEmitter();

  videoForm = new FormGroup({
    title: new FormControl('', [Validators.required]),
    subtitle: new FormControl('',),
    hasImage: new FormControl(false, [Validators.required]),
    image: new FormControl(null),
    link: new FormControl('', [Validators.required])
  });
  
  constructor() { }

  ngOnInit(): void {
    if (this.interaction) { // devo riempire i field
      this.populateForm();
    } else {
      this.interaction = {interactionType: 'video'};
    }
  }

  // convenience getter for easy access to form fields
  get f(): any {
    return this.videoForm.controls;
  }

  populateForm(): void {
    this.f.title.setValue(this.interaction.title);
    this.f.subtitle.setValue(this.interaction.subtitle);
    if (this.interaction.image) {
      this.f.hasImage.setValue(true);
      this.f.image.setValue(this.interaction.image);
    }
    this.f.link.setValue(this.interaction.interactionData.videoUrl);
  }

  setImageUrl(event): void {
    this.f.image.setValue(event ? event.filename : null);
    this.interaction.image = event ? event.filename : null;
  }

  validateTitle(): boolean {
    return !this.f.title.errors && !this.f.subtitle.errors;
  }

  setTitle(): void {
    this.interaction.title = this.f.title.value;
    if (this.f.hasImage) {
      this.interaction.image = this.f.image.value;
    }
    this.interaction.subtitle = this.f.subtitle.value;
  }

  validateContenuto(): boolean {
    let valid = true;
    if (this.f.hasImage.value) {
      if (!this.f.image.value) {
        valid = false;
      }
    }
    if (this.f.link.errors) {
      valid = false;
    }
    return valid;
  }

  onAddInteraction(): void {
    this.interaction.interactionData = {videoUrl: this.f.link.value};
    this.f.hasImage.value ? this.interaction.image = this.f.image.value : '';
    this.addInteraction.emit(this.interaction);
  }

}
